export default __webpack_public_path__ + "static/media/king1.4900bf60.png";